const API_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '');

const jsonHeaders = { 'Content-Type': 'application/json' };

const apiFetch = async (path, options = {}) => {
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...jsonHeaders,
      ...(options.headers || {})
    }
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `API request failed: ${response.status}`);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const getAllLeadBookers = () =>
  apiFetch('/lead-bookers');

export const saveLeadBookerOrder = (bookerIds) =>
  apiFetch('/lead-booker-order', {
    method: 'PUT',
    body: JSON.stringify({ bookerIds })
  });

export const saveLeadBooker = (booker) =>
  apiFetch('/lead-bookers', {
    method: 'POST',
    body: JSON.stringify(booker)
  });

export const deleteLeadBooker = (bookerId) =>
  apiFetch(`/lead-bookers/${bookerId}`, {
    method: 'DELETE'
  });

export const updateLeadBooker = (bookerId, updates) =>
  apiFetch(`/lead-bookers/${bookerId}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  });

export const getTeamsByBooker = (bookerId) =>
  apiFetch(`/bookers/${bookerId}/teams`);

export const saveTeamOrder = (bookerId, teamIds) =>
  apiFetch(`/bookers/${encodeURIComponent(bookerId)}/team-order`, {
    method: 'PUT',
    body: JSON.stringify({ teamIds })
  });

export const saveTeam = (bookerId, team) =>
  apiFetch(`/bookers/${bookerId}/teams`, {
    method: 'POST',
    body: JSON.stringify({ bookerId, team })
  });

export const deleteTeam = (bookerId, teamId) =>
  apiFetch(`/bookers/${bookerId}/teams/${teamId}`, {
    method: 'DELETE'
  });

export const removePlayer = (bookerId, teamId, playerId) =>
  apiFetch(`/bookers/${encodeURIComponent(bookerId)}/teams/${encodeURIComponent(teamId)}/players/${encodeURIComponent(playerId)}`, {
    method: 'DELETE'
  });

export const getBookerConfig = (bookerId) =>
  apiFetch(`/bookers/${bookerId}/config`);

export const saveBookerConfig = (bookerId, config) =>
  apiFetch(`/bookers/${bookerId}/config`, {
    method: 'PUT',
    body: JSON.stringify(config)
  });

// Export
export const exportData = (bookerId) => {
  const query = bookerId ? `?bookerId=${encodeURIComponent(bookerId)}` : '';
  return apiFetch(`/admin/export${query}`);
};

export const sendEmails = (bookerId) => {
  const body = bookerId ? { bookerId } : {};
  return apiFetch('/admin/send-emails', {
    method: 'POST',
    body: JSON.stringify(body)
  });
};

export const startExternalExport = (bookerId) =>
  apiFetch(`/admin/bookers/${encodeURIComponent(bookerId)}/external-exports`, {
    method: 'POST',
  });

export const getLatestExternalExports = () =>
  apiFetch('/admin/external-exports/latest');

export const resubmitExternalExportItem = (itemId) =>
  apiFetch(`/admin/external-export-items/${encodeURIComponent(itemId)}/resubmit`, {
    method: 'POST'
  });

export const getGlobalConfig = () =>
  apiFetch('/config');

export const saveGlobalConfig = (config) =>
  apiFetch('/config', {
    method: 'PUT',
    body: JSON.stringify(config)
  });

export const getPackages = () => apiFetch('/packages');
export const createPackage = (pkg) => apiFetch('/packages', {
  method: 'POST',
  body: JSON.stringify(pkg)
});

export const updatePackage = (id, pkg) => apiFetch(`/packages/${encodeURIComponent(id)}`, {
  method: 'PUT', body: JSON.stringify(pkg)
});
export const deletePackage = id => apiFetch(`/packages/${encodeURIComponent(id)}`, {
  method: 'DELETE'
});
